export default __webpack_public_path__ + "static/media/star-yellow.2bd96131.svg";